export const isDigitsKey = (key) => /^\d$/.test(key);
export const sanitizeDigits = (value) => {
    return value.replace(/\D/g, '');
};
export const generateEmpty = (length) => ' '.repeat(length);
export const isValid = (code, length) => {
    const stripped = code.replace(/\s/g, '');
    return stripped.length === length && /^\d+$/.test(stripped);
};
